const appConfig = {
  "name": "pi-dashboard",
  "version": "1.0.0",
  "stage": "master",
  "regions": [
    {
      "name": "us-east-1",
      "isPrimaryRegion": true,
      "deployThisBuild": true,
      "regionDomain": "get.atlas-config.mit.edu",
      "amplify": {
        "userPoolId": "us-east-1_bCu6BU8d2",
        "userPoolWebClientId": "30vd17jss9uo5qtibs46kf7e53",
        "oauth": {
          "domain": "atlas-auth.mit.edu",
          "scope": [
            "profile",
            "openid",
            "user/all",
            "digital-id/user"
          ],
          "redirectSignIn": "https://pi-dash.mit.edu",
          "redirectSignOut": "https://pi-dash.mit.edu/logout",
          "responseType": "token",
          "options": {
            "AdvancedSecurityDataCollectionFlag": false
          }
        }
      },
      "signInProvider": "Touchstone",
      "api": {
        "domain": "api.mit.edu",
        "paths": {
          "piDashboard": "pi-dash-v1",
          "feature": "feature-v1",
          "digital-id": "digital-id-v1"
        }
      }
    },
    {
      "name": "us-west-1",
      "isPrimaryRegion": false,
      "deployThisBuild": true,
      "regionDomain": "get.atlas-config.mit.edu",
      "amplify": {
        "userPoolId": "us-west-1_zsHXbydwR",
        "userPoolWebClientId": "71m1oevkp9blg99bq9d7mcnb06",
        "oauth": {
          "domain": "atlas-auth-us-west.mit.edu",
          "scope": [
            "profile",
            "openid",
            "digital-id/user",
            "digital-id/user"
          ],
          "redirectSignIn": "https://pi-dash.mit.edu",
          "redirectSignOut": "https://pi-dash.mit.edu/logout",
          "responseType": "token",
          "options": {
            "AdvancedSecurityDataCollectionFlag": false
          }
        }
      },
      "signInProvider": "Touchstone",
      "api": {
        "domain": "api-us-west.mit.edu",
        "paths": {
          "piDashboard": "pi-dash-v1",
          "feature": "feature-v1",
          "digital-id": "digital-id-v1"
        }
      }
    }
  ]
};
export default appConfig;